import { LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { SOCIALS_BUTTONS } from 'shared/constants/links';
import { NBSP } from 'shared/constants/symbols';
import { clsx } from 'clsx';
import { caJoinCommunity } from '../tracking';

export const BlueBanner: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['textblock']}>
        <div className={styles['title']}>Обменивайтесь опытом в{NBSP}сообществе хостов</div>
        <div className={styles['buttons']}>
          {SOCIALS_BUTTONS.map(({ id, title, url }) => (
            <div className={styles['btn']} key={id}>
              <Theme theme="onOverlay">
                <LinkButton
                  theme="fill_secondary"
                  size="L"
                  href={url}
                  onClick={caJoinCommunity}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {title}
                </LinkButton>
              </Theme>
            </div>
          ))}
        </div>
      </div>
      <div className={styles['image']} />
    </div>
  );
};
